import { BookOpenIcon, VideoCameraIcon } from "@heroicons/react/24/solid";
import React, { FC, ReactElement } from "react";
import YouTube from "react-youtube";

import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  SvgIcon,
} from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

import { useDialog } from "../hooks/use-dialog";
import Breadcrumbs from "./Breadcrumbs";
import OriginatorChip from "./OriginatorChip";

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactElement;
  breadcrumbs?: boolean;
  videoId?: string;
  helpUrl?: string;
  originatorId?: string;
}
const Header: FC<React.PropsWithChildren<Props>> = ({
  title,
  subtitle,
  actions,
  breadcrumbs,
  helpUrl,
  videoId,
  originatorId,
}) => {
  const videoDialog = useDialog();

  return (
    <Container
      sx={{
        pb: 2,
      }}
      maxWidth={false}
      disableGutters
    >
      <Dialog
        open={videoDialog.open}
        onClose={videoDialog.handleClose}
        scroll="paper"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
          {title} in Pomerium Zero
          <IconButton
            color="primary"
            onClick={videoDialog.handleClose}
            size="small"
            sx={{ ml: "auto" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <YouTube
            videoId={videoId || ""}
            opts={{ height: "465", width: "825" }}
          />
          <Box mb={4} />
        </DialogContent>
      </Dialog>
      <Stack spacing={2}>
        {breadcrumbs && <Breadcrumbs />}
        <Stack direction="row" gap={1} justifyContent="space-between">
          <Stack>
            <Stack direction="row">
              <Typography variant="h3" color="textPrimary" sx={{ mr: 1 }}>
                {title} <OriginatorChip originatorId={originatorId} />
              </Typography>
              {helpUrl && (
                <IconButton onClick={() => window.open(helpUrl, "_blank")}>
                  <SvgIcon color="primary" fontSize="small">
                    <BookOpenIcon />
                  </SvgIcon>
                </IconButton>
              )}
              {videoId && (
                <IconButton
                  color="primary"
                  onClick={() => videoDialog.handleOpen()}
                >
                  <SvgIcon color="primary" fontSize="small">
                    <VideoCameraIcon />
                  </SvgIcon>
                </IconButton>
              )}
            </Stack>
            {subtitle ? (
              <Typography variant="subtitle2" color="textPrimary">
                {subtitle}
              </Typography>
            ) : (
              <></>
            )}
          </Stack>
          {actions}
        </Stack>
      </Stack>
    </Container>
  );
};
export default Header;
